import { fieldResultsContent } from "./fieldResultsContent"

const headingClass =
  "text-balance text-[40px] font-bold leading-[48px] tracking-[-0.04em] text-[#171717] max-md:text-[28px] max-md:leading-8"

export default function FieldResultsSection() {
  return (
    <section className="ml-[calc(50vw-50%-1.5rem)] flex w-full flex-col items-start gap-12">
      <div className="flex w-full flex-col items-center gap-3 text-center">
        <p className="text-[14px] font-medium leading-5 text-[#4D4D4D]">
          {fieldResultsContent.stamp}
        </p>
        <h2 className={headingClass}>{fieldResultsContent.title}</h2>
      </div>
      <div className="grid w-full grid-cols-1 gap-y-12 md:grid-cols-3 md:gap-x-8">
        {fieldResultsContent.metrics.map((metric) => (
          <article key={metric.figure} className="flex flex-col items-center gap-6 text-center">
            <p className="text-[54px] font-bold leading-none tracking-[-0.02em] text-[#171717] tabular-nums max-md:text-[42px]">
              {metric.figure}
            </p>
            <div className="flex max-w-[32ch] flex-col gap-1">
              <p className="text-balance text-[16px] font-medium leading-6 text-[#171717]">
                {metric.subtitle}
              </p>
              <p className="text-balance text-[14px] font-normal leading-5 text-[#4D4D4D]">
                {metric.detail}
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}
